import React, { useState } from "react";
import Seo from "../components/Seo";

const inputCls =
  "w-full px-4 py-3 rounded-xl border border-slate-200 focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none";

function CandidatureForm() {
  const [f, setF] = useState({
    societe: "", nom: "", prenom: "", tel: "", email: "",
    siret: "", cp: "", ville: "", zone_intervention: "", message: "", website: "",
  });
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    try {
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/installateurs/candidature`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(f),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Une erreur est survenue, réessayez.");
      setStatus("sent");
    } catch (err) {
      setStatus("idle");
      setError(err.message);
    }
  };

  if (status === "sent") {
    return (
      <div data-testid="candidature-success" className="bg-white rounded-3xl p-12 text-center shadow-xl">
        <p className="text-5xl">✅</p>
        <h3 className="text-2xl font-extrabold text-slate-900 mt-4">Candidature bien reçue !</h3>
        <p className="text-slate-600 mt-3">
          Votre demande a été enregistrée. Notre équipe vous recontacte sous 48 h pour rejoindre le réseau
          installateurs THERMASOL.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="candidature-form" className="bg-white rounded-3xl p-8 shadow-xl text-left">
      <div className="grid md:grid-cols-2 gap-5">
        <div>
          <label className="block text-sm font-semibold mb-2 text-slate-700">Société *</label>
          <input data-testid="cand-societe" required value={f.societe} onChange={set("societe")} className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-slate-700">N° SIRET</label>
          <input data-testid="cand-siret" value={f.siret} onChange={set("siret")} className={inputCls} placeholder="14 chiffres" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-slate-700">Nom *</label>
          <input data-testid="cand-nom" required value={f.nom} onChange={set("nom")} className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-slate-700">Prénom</label>
          <input data-testid="cand-prenom" value={f.prenom} onChange={set("prenom")} className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-slate-700">Téléphone *</label>
          <input data-testid="cand-tel" required type="tel" value={f.tel} onChange={set("tel")} className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-slate-700">Email *</label>
          <input data-testid="cand-email" required type="email" value={f.email} onChange={set("email")} className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-slate-700">Code postal</label>
          <input data-testid="cand-cp" value={f.cp} onChange={set("cp")} className={inputCls} />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2 text-slate-700">Ville</label>
          <input data-testid="cand-ville" value={f.ville} onChange={set("ville")} className={inputCls} />
        </div>
      </div>
      <div className="mt-5">
        <label className="block text-sm font-semibold mb-2 text-slate-700">Zone d'intervention</label>
        <input data-testid="cand-zone" value={f.zone_intervention} onChange={set("zone_intervention")} className={inputCls} placeholder="Ex : Corse, PACA, national…" />
      </div>
      <div className="mt-5">
        <label className="block text-sm font-semibold mb-2 text-slate-700">Message</label>
        <textarea data-testid="cand-message" rows={4} value={f.message} onChange={set("message")} className={inputCls + " resize-none"} placeholder="Votre activité, vos qualifications, vos questions…" />
      </div>
      {/* Honeypot invisible anti-spam */}
      <input type="text" value={f.website} onChange={set("website")} tabIndex="-1" autoComplete="off" style={{ position: "absolute", left: "-9999px", height: 0, width: 0, opacity: 0 }} aria-hidden="true" />
      {error && <p data-testid="candidature-error" className="text-red-600 text-sm mt-4 font-semibold">{error}</p>}
      <button
        type="submit"
        disabled={status === "sending"}
        data-testid="candidature-submit"
        className="mt-6 w-full bg-orange-500 hover:bg-orange-600 disabled:opacity-60 text-white font-extrabold px-8 py-4 rounded-full transition-colors"
      >
        {status === "sending" ? "Envoi en cours…" : "Envoyer ma candidature"}
      </button>
      <p className="text-xs text-slate-400 mt-3 text-center">
        Vos coordonnées sont transmises directement à notre équipe commerciale. Réponse sous 48 h.
      </p>
    </form>
  );
}

const steps = [
  {
    n: "1",
    t: "ÉTUDE",
    d: "Dimensionnement du séchoir par notre bureau d'études : calepinage, bilan thermique, PVGIS.",
  },
  {
    n: "2",
    t: "FOURNITURE",
    d: "Équipement complet : panneaux, gaines, ventilation, régulation.",
  },
  {
    n: "3",
    t: "POSE",
    d: "Installation complète par nos équipes qualifiées, dans les règles de l'art.",
  },
  {
    n: "4",
    t: "MISE EN SERVICE",
    d: "Réception, réglages et formation de l'exploitant.",
  },
];

const avantages = [
  ["Le seul panneau PVT air éligible à la fiche AGRI-EQ-110", "Zéro rejet de dossier PNCEE."],
  ["Savoir-faire installation", "Chambre de séchage dimensionnée par notre bureau d'ingénierie."],
  ["Régulation développée en interne", "Pilotage du séchoir conçu par notre bureau d'ingénierie."],
  ["Une solution fournie et posée", "Pour un séchoir professionnel, clé en main."],
];

export default function InstallateursPage() {
  return (
    <main data-testid="installateurs-page" className="bg-white">
      <Seo
        title="Installateurs : séchoir solaire fourni et posé, étude de dimensionnement incluse | Thermasol Air Systems®"
        description="Réservé aux installateurs : Thermasol fournit l'ensemble des éléments du séchoir solaire (panneaux PVT air 550 Wc, gaines, ventilation, régulation), réalise l'étude de dimensionnement et la pose. Valorisez la fiche CEE AGRI-EQ-110 sans risque technique ni gestion administrative."
        canonical="https://thermasol-airsystems.fr/installateurs/"
        ogImage="https://thermasol-airsystems.fr/images/seo/panneau.webp"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Service",
            name: "Séchoir solaire clé en main pour installateurs",
            provider: { "@type": "Organization", name: "Thermasol Air Systems" },
            areaServed: "FR",
            description:
              "Étude de dimensionnement, fourniture complète des éléments du séchoir solaire PVT air et pose par équipes qualifiées, réservé aux installateurs partenaires.",
          },
        ]}
      />

      {/* HERO */}
      <section className="pt-28 pb-14 bg-slate-900">
        <div className="max-w-6xl mx-auto px-4 md:px-6 grid md:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-block bg-orange-500 text-white text-xs font-extrabold tracking-widest uppercase px-4 py-1.5 rounded-full">
              Réservé aux installateurs
            </span>
            <h1 className="text-4xl sm:text-5xl font-extrabold text-white leading-tight mt-5">
              Installateurs : valorisez la fiche CEE AGRI-EQ-110
            </h1>
            <p className="text-slate-300 mt-6 leading-relaxed">
              THERMASOL, fabricant du panneau solaire PVT air — technologie hybride déposée INPI, éligible aux aides de
              l'État. Un seul panneau produit de l'électricité ET de l'air chaud, récupéré en sous-face pour sécher
              bois, fourrage, céréales et plantes. Un séchoir solaire complet, sans gaz ni fioul —{" "}
              <strong className="text-white">fourni, dimensionné et posé par nos équipes</strong>.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href="#rejoindre"
                data-testid="cta-rejoindre-hero"
                className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-4 rounded-full text-center transition-colors"
              >
                Rejoindre le réseau installateurs
              </a>
              <a
                href="/docs/flyer-installateurs-thermasol.pdf"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-flyer-pdf"
                className="bg-white/10 hover:bg-white/20 border border-white/40 text-white font-bold px-8 py-4 rounded-full text-center transition-colors"
              >
                📄 Télécharger le flyer PDF
              </a>
            </div>
          </div>
          <img
            src="/images/seo/panneau.webp"
            alt="panneau PVT air Thermasol 550 pour installateurs séchoir solaire"
            className="rounded-2xl shadow-2xl w-full object-cover"
            width="1264"
            height="848"
            loading="eager"
          />
        </div>
      </section>

      {/* CHIFFRES */}
      <section className="bg-orange-500">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          {[
            ["550 Wc", "Électrique"],
            ["1 397 Wth", "Thermique"],
            ["> 2 170 W", "Cumulés par panneau"],
            ["INPI", "Technologie hybride déposée"],
          ].map(([v, l]) => (
            <div key={l}>
              <p className="text-3xl font-extrabold text-white">{v}</p>
              <p className="text-orange-100 text-sm font-semibold uppercase tracking-wide mt-1">{l}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ON FAIT TOUT */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 text-center">
            On fait tout, de l'étude à la mise en service
          </h2>
          <p className="text-slate-600 text-center mt-3 max-w-2xl mx-auto">
            Une solution complète, fournie et posée. Vous n'avez plus qu'à commercialiser.
          </p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
            {steps.map((s) => (
              <div
                key={s.n}
                data-testid={`etape-${s.n}`}
                className="bg-slate-50 border border-slate-200 rounded-2xl p-6 relative"
              >
                <div className="w-12 h-12 rounded-full bg-orange-500 text-white font-extrabold text-xl flex items-center justify-center">
                  {s.n}
                </div>
                <p className="font-extrabold text-slate-900 tracking-wide mt-4">{s.t}</p>
                <p className="text-slate-600 text-sm leading-relaxed mt-2">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AVANTAGES + CEE */}
      <section className="py-16 bg-slate-900">
        <div className="max-w-6xl mx-auto px-4 md:px-6 grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-white">L'avantage THERMASOL</h2>
            <ul className="mt-6 space-y-5">
              {avantages.map(([t, d]) => (
                <li key={t} className="flex gap-4">
                  <span className="text-orange-400 text-xl leading-none mt-0.5">◆</span>
                  <div>
                    <p className="text-white font-bold">{t}</p>
                    <p className="text-slate-400 text-sm mt-1">{d}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8">
            <h2 className="text-2xl md:text-3xl font-bold text-white">Valorisation CEE assurée</h2>
            <p className="text-slate-300 mt-4 leading-relaxed">
              Par notre partenaire <strong className="text-white">Eco Environnement</strong>, mandataire{" "}
              <strong className="text-white">TotalEnergies</strong> : dossier monté, sécurisé et financé.
              Zéro paperasse pour vous. La prime est déduite directement du devis de votre client.
            </p>
            <ul className="mt-6 space-y-3">
              {[
                "Votre marge sur chaque affaire signée",
                "Aucun risque technique",
                "Aucune gestion administrative CEE",
              ].map((x) => (
                <li key={x} className="flex items-center gap-3 text-white font-semibold">
                  <span className="w-6 h-6 rounded-full bg-emerald-500 text-white text-sm flex items-center justify-center">✓</span>
                  {x}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CIBLES */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900">
            Des clients finaux éligibles aux aides de l'État
          </h2>
          <p className="text-slate-600 mt-3 max-w-2xl mx-auto">
            Solution éligible aux Certificats d'Économies d'Énergie, fiche{" "}
            <a href="/fiche-cee-agri-eq-110" className="text-orange-600 font-semibold underline" data-testid="link-fiche-cee-installateurs">
              AGRI-EQ-110
            </a>
            . Séchage de fourrage, bois, céréales et plantes.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10">
            {[
              ["🪵", "Scieries", "Séchage de bois basse température, valorisation immédiate des sciages."],
              ["🌾", "Agriculteurs", "Fourrage, céréales, plantes : un séchoir solaire sans gaz ni fioul."],
              ["🏭", "Coopératives", "Des volumes importants séchés à coût d'exploitation minimal."],
            ].map(([i, t, d]) => (
              <div key={t} className="bg-slate-50 border border-slate-200 rounded-2xl p-8">
                <p className="text-4xl">{i}</p>
                <p className="font-extrabold text-slate-900 mt-3">{t}</p>
                <p className="text-slate-600 text-sm mt-2 leading-relaxed">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CANDIDATURE */}
      <section id="rejoindre" className="py-16 bg-slate-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 text-center">
            Devenir installateur partenaire
          </h2>
          <p className="text-slate-600 text-center mt-3 mb-10">
            Remplissez ce formulaire : votre candidature arrive directement dans notre CRM et notre équipe vous
            recontacte sous 48 h.
          </p>
          <CandidatureForm />
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="py-16 bg-orange-500">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-extrabold text-white">
            Rejoignez le réseau installateurs THERMASOL
          </h2>
          <p className="text-orange-100 mt-3">
            Étude de dimensionnement, fourniture de l'ensemble des éléments du séchoir et pose : on s'occupe de tout.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+33184190449"
              data-testid="cta-tel-installateurs"
              className="bg-white text-orange-600 font-extrabold px-8 py-4 rounded-full transition-transform hover:scale-105"
            >
              📞 01 84 19 04 49
            </a>
            <a
              href="mailto:contact@thermasol-airsystems.fr?subject=Réseau installateurs THERMASOL"
              data-testid="cta-email-installateurs"
              className="bg-slate-900 hover:bg-slate-800 text-white font-bold px-8 py-4 rounded-full transition-colors"
            >
              ✉️ contact@thermasol-airsystems.fr
            </a>
            <a
              href="/contact"
              data-testid="cta-contact-installateurs"
              className="bg-white/15 border border-white text-white font-bold px-8 py-4 rounded-full transition-colors hover:bg-white/25"
            >
              Formulaire de contact
            </a>
          </div>
          <p className="text-orange-100/80 text-xs mt-8">
            Fabricant — Technologie hybride déposée INPI · France Énergie — SIRET 899 346 217 00024 — Yerres (91330) ·
            Éligibilité CEE sous réserve des conditions en vigueur.
          </p>
        </div>
      </section>
    </main>
  );
}
